import { useState } from 'react';

export const useModalHolidayDetails = () => {
  const [holidayId, setHolidayId] = useState<string | null>(null);
  const isOpen = !!holidayId;

  const closeModal = () => {
    setHolidayId(null);
  };

  const openHolidayDetailsModal = (holidayId: string) => {
    setHolidayId(holidayId);
  };

  return { holidayId, isOpen, closeModal, openHolidayDetailsModal };
};
